const getDeals = (state) => state.deals;
const getDealsSubscriptions = (state) => getDeals(state).subscriptions;

export default {
  getIsSubscribed: (state) => getDealsSubscriptions(state).isSubscribed,
  getIsSubscriptionsFetching: (state) => getDealsSubscriptions(state).isFetching,
  getIsModalSpinnerVisible: (state) => getDealsSubscriptions(state).isFetching,
  getSubscriptionId: (state) => getDealsSubscriptions(state).subscriptionId,
};
